import { defineMessages } from 'react-intl-next';

const commonMessages = defineMessages({
	fieldRequired: {
		id: 'eoc.escalation-policies.ui.common.required.no-translate',
		defaultMessage: 'This field is required',
		description: 'Error message that shown required input is empty',
	},
	alreadyExist: {
		id: 'eoc.escalation-policies.ui.common.already-exist.no-translate',
		defaultMessage: 'Escalation with this name {name} already exists.',
		description: 'Error message that shown if escalation policy exist with same name',
	},
	errorTitle: {
		id: 'eoc.escalation-policies.flag.error-title.no-translate',
		defaultMessage: 'Error',
		description: 'Title of error message that will be displayed in the flag',
	},
	successTitle: {
		id: 'eoc.escalation-policies.flag.success-title.no-translate',
		defaultMessage: 'Success',
		description: 'Title of success message that will be displayed in the flag',
	},
	enabled: {
		id: 'eoc.global-escalations.status.on.no-translate',
		defaultMessage: 'On',
		description: 'The label of enabled status',
	},
	disabled: {
		id: 'eoc.global-escalations.status.off.no-translate',
		defaultMessage: 'Off',
		description: 'The label of disabled status',
	},
	edit: {
		id: 'eoc.escalation-policies.ui.actions.edit.no-translate',
		defaultMessage: 'Edit',
		description: 'Label of edit button',
	},
	clone: {
		id: 'eoc.escalation-policies.ui.actions.clone.no-translate',
		defaultMessage: 'Duplicate',
		description: 'Label of clone button',
	},
	disable: {
		id: 'eoc.escalation-policies.ui.actions.disable.no-translate',
		defaultMessage: 'Turn off',
		description: 'Label of disable button',
	},
	enable: {
		id: 'eoc.escalation-policies.ui.actions.enable.no-translate',
		defaultMessage: 'Turn on',
		description: 'Label of enable button',
	},
	delete: {
		id: 'eoc.escalation-policies.ui.actions.delete.no-translate',
		defaultMessage: 'Delete',
		description: 'Label of delete button',
	},
	showMore: {
		id: 'eoc.escalation-policies.ui.actions.show-more.no-translate',
		defaultMessage: 'Show Actions of {name}',
		description: 'Label of show more button',
	},
	title: {
		id: 'eoc.global-escalations.header.title.no-translate',
		defaultMessage: 'Escalation policies',
		description: 'The title of global escalations',
	},
});

export default commonMessages;
